import { type ReactNode } from 'react'

import './_changeStateTabs.scss'

type Tab = {
    name: string | ReactNode
    value: string
}

type ChangeStateTabsProps = {
    activeTab: string
    tabs: Tab[]
    clickFn: (val: string) => void
    width: string
    customClass?: string
    hasInfoCircle?: boolean
    infoCircleData?: number
}

const ChangeStateTabs = ({
    activeTab,
    tabs,
    clickFn,
    width,
    hasInfoCircle,
    infoCircleData,
    customClass
}: ChangeStateTabsProps) => {
    return (
        <div className={`csTabs csTabs--${width} ${customClass ?? ''}`}>
            {tabs.map((tab: Tab, key: number) => (
                <div
                    key={key}
                    className={`csTabs__tab ${
                        activeTab === tab.value ? 'csTabs__tab--active' : ''
                    }`}
                    onClick={() => {
                        clickFn(tab.value)
                    }}
                >
                    {tab.name}
                </div>
            ))}

            {hasInfoCircle ? (
                <div className='csTabs__infocircle'>{infoCircleData}</div>
            ) : (
                ''
            )}
        </div>
    )
}

export default ChangeStateTabs
